/** @jsxImportSource @emotion/react */
import { Trans } from '@lingui/react/macro';
import React from 'react';
import { SUPPORT_URL } from 'shared/constants/links';
import * as S from './styles';

interface IStubSupportLinkProps {
  className?: string;
}

function StubSupportLink(props: IStubSupportLinkProps) {
  const { ...rest } = props;

  return (
    <S.SupportLink to={SUPPORT_URL} {...rest}>
      <Trans>Нужна помощь? Связаться с поддержкой.</Trans>
    </S.SupportLink>
  );
}

export default StubSupportLink;
